import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'warning' // 'warning' | 'success' | 'danger'
}) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  const iconColors = {
    warning: 'text-yellow-500',
    success: 'text-green-500',
    danger: 'text-red-500',
  };

  const buttonColors = {
    warning: 'bg-yellow-500 hover:bg-yellow-600',
    success: 'bg-green-500 hover:bg-green-600',
    danger: 'bg-red-500 hover:bg-red-600',
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="glass-card p-6 max-w-md w-full animate-in fade-in zoom-in duration-200" data-testid="confirmation-modal">
        <div className="flex items-center gap-4 mb-4">
          {type === 'success' ? (
            <CheckCircle className={`w-12 h-12 ${iconColors[type]}`} />
          ) : (
            <AlertTriangle className={`w-12 h-12 ${iconColors[type]}`} />
          )}
          <div>
            <h3 className="text-xl font-bold">{title}</h3>
            <p className="text-muted-foreground text-sm mt-1">{message}</p>
          </div>
        </div>
        
        <div className="p-3 bg-yellow-500/10 rounded-lg border border-yellow-500/20 mb-6">
          <p className="text-sm text-yellow-500 flex items-center gap-2">
            <AlertTriangle className="w-4 h-4" />
            {t('doubleCheck')}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-white/10 rounded-full font-semibold hover:bg-white/20 transition-all"
            data-testid="cancel-button"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 px-4 py-3 rounded-full font-semibold text-white transition-all ${buttonColors[type]}`}
            data-testid="confirm-button"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
